import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/glide-g': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M407.1 211.2c7.5 2.9 40.9 55.4 40.9 63.4 0 2.9-3.8 5.8-6.7 5.8-28.4-4.7-41.1-8.4-58.9-8.4-36.3 0-61.6 10.8-93.8 27-8.5 4.3-4.6 7.1-19.7 67.6-17.4 67.6-74 145.4-151.4 145.4-52.7 0-85.5-36-85.5-87.9 0-28.1 18.5-79.2 52.4-79.3 11.9 0 58.6 15.4 58.9 27.6-0.5 2.4-45.5 21.8-45.5 61 0 38.5 73.9 34.3 90.8-94.6 0-4.8 1-3.8-11-3.8-87.3 0-138.6-48.7-138.6-136.6 0-84.7 58.3-198.4 173.4-198.4 70.2 0 108.4 29.1 108.4 100.6 0 48.5-16.5 93.1-23.5 140.4l0.9 0.9c31.3-17.7 56.4-34.5 93.5-34.5 3.8 0 11.9 2.4 15.4 3.8zM231.8 126.8c2.9-13.9 5.5-28.1 5.6-42.4 0-15.4-1.4-28.7-20-28.7-7.8 0-15.6 2.6-22.6 6.7-43.8 24.1-61.8 86.4-61.8 133.4 0 31.3 10.7 73.1 49 73.1 8.7 0 19.7 2.4 22-7.8 9.2-44.7 18.5-89.6 27.8-134.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/glide-g.js
// module id = 860
// module chunks = 0